<template>
    <b-modal v-model="modal.show"
             hide-footer
             centered
             size="lg"
             title="Crear tarea"
    >
        <b-form @submit.prevent="validateForm()"
                data-vv-scope="tasks">
            <b-row>
                <b-col cols="12">
                    <b-form-group>
                        <label for="name">Nombre</label>
                        <el-input id="name"
                                  name="name"
                                  size="small"
                                  v-model="task.name"
                                  data-vv-as=" "
                                  v-validate="'required|min:3|max:255'"
                                  maxlength="255"
                                  show-word-limit
                        />
                        <div class="text-danger small"
                             v-text="errors.first('tasks.name')"
                        />

                    </b-form-group>
                </b-col>

                <b-col cols="12">
                    <b-form-group>
                        <label for="description">Descripción</label>
                        <el-input id="description"
                                  name="description"
                                  type="textarea"
                                  size="small"
                                  v-model="task.description"
                                  data-vv-as=" "
                                  v-validate="'required|min:3|max:1000'"
                                  maxlength="1000"
                                  show-word-limit
                        />
                        <div class="text-danger small"
                             v-text="errors.first('tasks.description')"
                        />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col class="text-center">
                    <hr/>

                    <b-btn variant="primary"
                           class="mx-1"
                           size="sm"
                           @click="validateForm()"
                    >
                        <i class="fa fa-save"/> Crear
                    </b-btn>
                    <b-btn variant="secondary"
                           class="mx-1"
                           size="sm"
                           @click="setModalShow(false)"
                    >
                        <i class="fa fa-close"/> Cancelar
                    </b-btn>
                </b-col>
            </b-row>
        </b-form>
    </b-modal>
</template>


<script>
import {mapState, mapMutations, mapActions} from 'vuex';

export default {
    name: 'modal_task',
    computed: {
        ...mapState('tasks', [
            'task',
            'modal'
        ]),
        ...mapState('analysis', [
            'tarea'
        ]),
    },
    methods: {
        ...mapActions('analysis', [
            'fetchTasks'
        ]),
        ...mapActions('tasks', [
            'addTask'
        ]),
        ...mapMutations('tasks', [
            'setModalShow',
        ]),
        validateForm() {
            this.$validator.validateAll('task')
                .then(async (result) => {
                    if (result) {
                        await this.addTask(this.tarea.id_empresa);
                        await this.fetchTasks();
                    }
                });
        }
    }
};
</script>

<style>
.translate-enter-active,
.translate-leave-active {
    transition: all 0.5s ease;
}

.translate-enter-from,
.translate-leave-to {
    opacity: 0;
    transform: translateX(30px);
}
</style>
